import DatePicker from '../../../components/field/DatePicker.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class datePickerComponent extends InlineComponent {
  define() {
    this.component = DatePicker;
  }
};
